var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserFallbackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.414 11.931a5.843 5.843 0 00-1.26-1.867 5.868 5.868 0 00-1.867-1.26l-.018-.007a3.874 3.874 0 10-4.538.002l-.018.007c-.7.296-1.329.719-1.868 1.26a5.87 5.87 0 00-1.72 4.025.125.125 0 00.125.128h.938a.125.125 0 00.125-.122 4.658 4.658 0 011.371-3.192A4.657 4.657 0 018 9.53c1.253 0 2.43.488 3.316 1.374a4.658 4.658 0 011.371 3.192.124.124 0 00.126.122h.937a.125.125 0 00.125-.128 5.823 5.823 0 00-.46-2.16zM8 8.344a2.67 2.67 0 01-1.9-.788 2.67 2.67 0 01-.787-1.9c0-.717.28-1.392.787-1.9A2.67 2.67 0 018 2.97c.717 0 1.392.28 1.9.787a2.67 2.67 0 01.787 1.9 2.67 2.67 0 01-.787 1.9 2.67 2.67 0 01-1.9.788z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/UserFallbackWhite.1fed6ce50adbad800e229cbfb922b3e3.svg";
export { SvgUserFallbackWhite as ReactComponent };